import { render } from "./InputSingleSelect.vue?vue&type=template&id=32b7474d"
import script from "./InputSingleSelect.vue?vue&type=script&lang=ts"
export * from "./InputSingleSelect.vue?vue&type=script&lang=ts"
script.render = render

export default script